export const TALESPIRE_SYMBIOTE_DOCS_URL = 'https://symbiote-docs.talespire.com/user_docs.html';
export const TALESPIRE_SYMBIOTE_FOLDER = 'Darkfeld Combat';

export function buildTaleSpireManifest(origin: string): string {
  const appOrigin = new URL(origin).origin;
  return `${JSON.stringify({
    manifestVersion: 1,
    name: 'Darkfeld Combat',
    summary: 'Publishes trusted Darkfeld combat results to TaleSpire dice history and board chat.',
    version: '0.2.0',
    entryPoint: `${appOrigin}/symbiotes/talespire/v1/index.html`,
    about: {
      website: appOrigin,
      authors: ['Darkfeld'],
    },
    api: {
      version: '0.1',
      initTimeout: 10,
      interop: {
        id: '96f061e4-090d-4bd0-a9b7-608282732f55',
      },
      subscriptions: {
        symbiote: {
          onStateChangeEvent: 'handleDarkfeldStateChange',
        },
        creatures: {
          onCreatureSelectionChange: 'handleDarkfeldCreatureSelection',
          onCreatureStateChange: 'handleDarkfeldCreatureState',
        },
        picking: {
          onPickingEvent: 'handleDarkfeldPicking',
        },
        initiative: {
          onInitiativeEvent: 'handleDarkfeldInitiative',
        },
        sync: {
          onSyncMessage: 'handleDarkfeldSync',
        },
      },
    },
    controls: {
      reload: true,
      navigation: false,
    },
    environment: {
      webViewBackgroundColor: '#0a0e27',
      loadTargetBehavior: 'popup',
      capabilities: ['runInBackground'],
      extras: ['colorStyles'],
    },
  }, null, 2)}\n`;
}

export async function downloadTaleSpirePackage(): Promise<void> {
  const zip = new JSZip();
  const folder = zip.folder(TALESPIRE_SYMBIOTE_FOLDER)!;
  folder.file('manifest.json', buildTaleSpireManifest(window.location.origin));
  folder.file('README.md', `# Darkfeld Combat

This Symbiote publishes trusted Darkfeld combat rolls to TaleSpire.

Extract this archive into TaleSpire's Symbiotes directory, then open Darkfeld Combat and sign in with Discord. The Symbiote UI is hosted by Darkfeld, so updates do not require reinstalling this package.
`);
  const blob = await zip.generateAsync({ type: 'blob', compression: 'DEFLATE' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'darkfeld-combat-talespire.zip';
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
import JSZip from 'jszip';
